import React from 'react';
import classNames from 'classnames';
import styles from './TabBadge.scss';

export default function TabBadge({ className, children, isUnread }) {
  return (
    <span
      className={classNames(
        styles.badge,
        isUnread && styles.isUnread,
        className,
      )}
    >
      {children}
    </span>
  );
}
